import React from 'react';
import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 60, scale: 0.95 },
  visible: { opacity: 1, y: 0, scale: 1 },
};

const Newsec = () => {
  return (
    <section className="bg-white py-20 px-6 sm:px-12 lg:px-24 font-sans">
      <motion.div
        className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.3 }}
        variants={fadeUp}
        transition={{ duration: 1.2 }}
      >
        {/* Left text content */}
        <div>
          <h2 className="text-xl text-gray-800 font-normal" style={{ fontSize: '32px' }}>
            Meet Our Horses
          </h2>
          <br />
          <p className="text-gray-700 text-base sm:text-lg leading-relaxed" style={{ fontSize: '16px' }}>
            Each horse at Ashwalaya is raised with patience, purpose, and pride.
            From young foals discovering the rhythm of the desert to seasoned stallions leading long-distance safaris, 
            our herd reflects the living spirit of Marwar. Trained using natural horsemanship methods, our horses are calm, intelligent, 
            and deeply connected to their riders. Every guest is thoughtfully paired with a horse based on comfort, experience, 
            and energy—to ensure a safe, meaningful, and unforgettable journey.
          </p>
        </div>

{/* Right image */}
<div className="w-full flex justify-center">
  <img
    src="/images/hor4.jpg"
    alt="Meet Our Horses"
    className="rounded-xl shadow-lg w-[440px] h-[610px] object-cover"
  />
</div>


      </motion.div>
    </section>
  );
};

export default Newsec;
